<template>
  <div>
    <!-- 状态修改弹窗 -->
    <dashboard-state-dialog
      v-if="stateDialog.visible"
      :visible.sync="stateDialog.visible"
      :rows="stateDialog.rows"
      :filter="stateDialog.filter"
      :tracking-list="stateDialog.trackingList"
      :sop-node-state="sopNodeState"
      @callback="onCallback"
    />
  </div>
</template>

<script>
import DashboardStateDialog from '@/components/Cargo/Job/DashboardStateDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import { getTrackingListByLob } from '@/api/seaExport/seaExportJob'

export default {
  name: 'ModifyStateWindow',
  components: { DashboardStateDialog },
  data() {
    return {
      isSop: false,
      tenantInstruction: {
        uuid: '',
        platformInstructionCode: '',
        allowMultipleOperations: false
      },
      sopNode: '',
      sopNodeState: '',
      stateDialog: {
        visible: false,
        rows: [],
        filter: {},
        trackingList: []
      }
    }
  },
  methods: {
    // UI自定义使用
    onShowOfUI(uiInstruction, job) {
      this.isSop = false
      this.tenantInstruction.uuid = uiInstruction.tenantInstructionUuid
      this.tenantInstruction.platformInstructionCode = uiInstruction.platformInstructionRuleCode
      this.tenantInstruction.allowMultipleOperations = uiInstruction.allowMultipleOperations || false
      if (uiInstruction.instructionParamJson) {
        this.sopNode = uiInstruction.instructionParamJson.sopnode || ''
        this.sopNodeState = uiInstruction.instructionParamJson.sopnodestate || ''
      } else {
        this.sopNode = ''
        this.sopNodeState = ''
      }
      this.stateDialog.filter = { code: this.sopNode, trackingTemplateUuid: job.trackingTemplateUuid }
      this.showStateDialog([job])
    },
    // SOP面板使用
    onShowOfSOP(sopInstruction, jobs, filter) {
      this.isSop = true
      this.tenantInstruction.uuid = sopInstruction.uuid
      this.tenantInstruction.platformInstructionCode = sopInstruction.platformInstructionCode
      this.tenantInstruction.allowMultipleOperations = sopInstruction.allowMultipleOperations || false
      if (sopInstruction.instructionParamJson) {
        this.sopNode = sopInstruction.instructionParamJson.sopnode || ''
        this.sopNodeState = sopInstruction.instructionParamJson.sopnodestate || ''
      } else {
        this.sopNode = ''
        this.sopNodeState = ''
      }
      this.stateDialog.filter = { ...filter, code: this.sopNode }
      this.showStateDialog(jobs)
    },
    showStateDialog(jobs) {
      if (!jobs || jobs.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      let lob = null
      for (const item of jobs) {
        if (lob !== null && lob !== item.lob) {
          this.$message.warning(this.$t('Message.PleaseSelectTheSameTypeOfJob'))
          return
        }
        lob = item.lob
      }
      getTrackingListByLob(lob).then(res => {
        this.stateDialog.trackingList = res.data
        this.stateDialog.rows = jobs
        this.stateDialog.visible = true
      })
    },
    onCallback() {
      const loading = getLoading4Cxt(this)
      generateInstructionRecord({ jobUuids: this.stateDialog.rows.map(job => job.uuid), executeStatus: true, instructionUuid: this.tenantInstruction.uuid }).then(res => {
        this.$emit('callback')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>
